const getLegalHubLinks = (legalHub)=>{
    return legalHub.map((link)=>{
        return {
            href: link?.path,
            title: link?.title || '',
            withOneTrust: link.path.includes('manage-cookies') || link.path.includes('ccpa')
        };
    });
};

export { getLegalHubLinks };
